import * as React from 'react';

export const Privacy = () => {
    return (
        <div className="py-3 py-lg-4">
            <h2>Privacy</h2>
            <div className="card card-lg">
                <div className="card-header bg-dark py-sm-5">
                    <h1 className="card-title h2 text-white">Privacy & Policy</h1>
                    <p className="card-text text-white">Last modified: October 24, 2022</p>
                </div>
                <div className="card-body">
                    <div className="mb-5">
                        <h4>Introduction</h4>
                        <p>Your privacy and personal information are important to us. This privacy statement explains the personal information we collects, how we processes it and for what purposes.</p>
                        <p>References to products in this statement include services, software applications and websites.</p>
                    </div>

                    <div className="mb-5">
                        <h4 id="personal_data">Personal data we collect</h4>
                        <p>We may collect data from you, through our interactions with you such as during the sales and support process. The data we collect depends on the interactions we have with you and your organization. We will never collect sensitive information about you without your explicit consent. We will only use the information that we collects about you lawfully (in accordance with the Data Protection Act 1998).</p>
                        <p>The type of information we will collect about you includes:</p>
                        <ul>
                            <li>Company Name</li>
                            <li>Contact Name</li>
                            <li>Address </li>
                            <li>Phone number </li>
                            <li>Email address </li>
                            <li>Credit/Debit card details </li>
                        </ul>
                    </div>

                    <div className="mb-5">
                        <h4 id="data_usage">How we use personal data</h4>
                        <p>We collect information about you for the following reasons.</p>
                        <ul>
                            <li>To provide the products and services you have requested.</li>
                            <li>Provide our products, which includes updating, securing, and troubleshooting, as well as providing support.</li>
                            <li>Improve and develop our products.</li>
                            <li>We may also use personal information for auditing, research and analysis to operate and improve technologies and services.</li>
                            <li>We will not share any information you provide with third parties outside.</li>
                        </ul>
                        <p>We will give you the chance to refuse any marketing email from us in the future.</p>

                        <p>
                            We will make best efforts to keep the your information accurate and up to date. You can check the information that
                            we hold about you by emailing us. If you find any inaccuracies we will delete or correct it promptly.
                        </p>
                        <p>
                            The personal information which we hold will be held securely in accordance with our internal security policy and the law.
                        </p>
                        <p>
                            We may use technology to
                            track the patterns of behavior of visitors to our site. This can
                            include using a &quot;cookie&quot; which would be stored on your browser. You
                            can usually modify your browser to prevent this from happening. The
                            information collected in this way can be used to identify you unless
                            you modify your browser settings.
                        </p>
                    </div>

                    <div className="mb-5">
                        <h4 id="app_statement">Software applications installed on your devices or hosted in the cloud</h4>
                        <p>All applications installed on your devices or hosted in the cloud do not collect personal information or information that can be used to identify.</p>
                    </div>

                    <div className="mb-5">
                        <h4 id="contact">How to contact us</h4>
                        <p>If you have a privacy concern, complaint, or question, please contact us by mail or email.
                            We will respond to questions or concerns as required by law and within a period no longer than 30 days.
                            You can also raise a concern or lodge a complaint with a data protection authority or other official with jurisdiction.</p>
                        <p>Our addresses are:</p>
                        <div className="row">
                            <div className="col-md-6">
                                <address>
                                    <p>
                                        Title<br />
                                        Street<br />
                                        City, State 00000
                                    </p>
                                    <abbr title="Toll Free">P:</abbr>
                                    <a href="tel:+15553334455">555.333.4455</a>
                                </address>

                                <div className="d-inline fw-bold">Info</div>
                                <div className="d-inline p-2"><a href="mailto:Info@algorythms.biz">info</a></div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default Privacy;